import { Node, mergeAttributes } from "@tiptap/core";

// Node atômico de variável: aparece como chip no editor e serializa
// como <span data-variable="x">{{x}}</span> — o backend roda Mustache
// direto no HTML salvo.
const TemplateVariableNode = Node.create({
  name: "templateVariable",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  // Permite negrito/itálico/fonte/tamanho no chip, para a variável
  // acompanhar a formatação do texto ao redor (inclusive no PDF)
  marks: "_",

  addAttributes() {
    return {
      name: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-variable") || "",
      },
      label: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-label") || "",
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-variable]" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-variable": node.attrs.name,
        "data-label": node.attrs.label || undefined,
        class: "tpl-var",
      }),
      `{{${node.attrs.name}}}`,
    ];
  },

  renderText({ node }) {
    return `{{${node.attrs.name}}}`;
  },
});

export default TemplateVariableNode;
